import { DataResponse } from 'services/response';
import { BASE_API_URL } from "utils/constants";
import { downloadFilePostNew, get, post } from '../../utils/api';


// Báo cáo tổng hợp khách hàng
export type CustomerGeneral = {
  stt: number
  profileId: string
  profileCode: string
  customerGroupName?: string
  profileForeignCode?: string
  createAtCompanyName: string
  profileShortName?: string
  countryName?: string
  reconcileAccountName?: string
  paymentTermName?: string
  customerAccountAssignmentGroupName?: string
  titleType?: string
  partherFunctionName: any
  paymentMethodName: any
  currencyName: any
  taxClassificationName: any
  managerName: any
  managerCode: any
  debsEmployeeCode: any
  debsEmployeeName: any
  title?: string
  profileName: string
  isForeignCustomer: boolean
  foreignCustomer: string
  address: string
  customerTypeName?: string
  phone: string
  phone1?: string
  phone2: any
  email?: string
  customerSourceName?: string
  saleOrgName: string
  age: any
  taxNo?: string
  customerCareerName?: string
  saleOfficeCode: string
  note?: string
  personInChargeCode?: string
  personInCharge?: string
  roleInCharge?: string
  dateOfBirth: any
  addressTypeName: string
  addressTypeCode: string
  saleEmployee?: string
  createUser: any
  createTime: string
  emailHDDT: any
  actived: boolean
  personInCharge6Code: any
  personInCharge6Name: any
  closeVisitDate: any
  adminEmployeeName: any
  phanHang: any
  saleOfficeName3: string
  wardName3?: string
  districtName3?: string
  provinceName3: string
  address3: string
  addressTypeName3: string
  isMain: string
  orderbyIsMain: number
  saleOfficeName: string
  wardName?: string
  districtName?: string
  provinceName: string
  address1: string
  address2: any
  addressTypeName1: string
  addressTypeName2: any
  profileContractId: any
  contactCode?: string
  contactName?: string
  contactEmail: any
  contactDepartmentName?: string
  contactPositionName?: string
}

export type CustomerModel = {
  stt: number
  profileId: string
  profileCode: string
  profileForeignCode: any
  profileName: string
  profileShortName: string
  profilePhone: string
  taxNo: any
  isForeignCustomer: boolean
  customerTypeName: string
  customerSourceName: string
  saleOrgName: string
  age: any
  customerCareerName: string
  note: any
  createUser: string
  createTime: string
  actived: boolean
  isTopInvestor: boolean
  customerGroupName: string
  personInCharege: any
  roleInCharge: string
  phanHang: any
  profileAddress: string
  wardAppellation: string
  wardName: string
  districtAppellation: string
  districtName: string
  provinceName: string
  saleOfficeCode: string
  saleOfficeName: string
  addressTypeName2: string
  isMainAddress: boolean
  adminEmployeeName: string
  phone: string
  address: string
  email: any
}

// ============ Khai báo phương thức =====================
export interface ICustomerGeneralReportServices {
  // lấy dữ liệu báo cáo
  getDataDetail(data: object): Promise<DataResponse<CustomerGeneral[]>>

  // lấy danh sách khách hàng
  getListCustomer(data: object): Promise<DataResponse<CustomerModel[]>>

  // export excel
  exportExcel(data: object): Promise<void>

}
// Hàm khởi tạo các phương thức
export function createCustomerGeneralReportServices(): ICustomerGeneralReportServices {
  return {
    getDataDetail: async (data: object) => {
      return (await post(BASE_API_URL, `Reports/report-profile-report`, data)).data
    },
    getListCustomer: async (data: object) => {
      return (await post(BASE_API_URL, `Common/get-list-profile-popup`, data)).data
    },
    // export excel
    exportExcel: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-profile-report`, data))
    },
  };
}
